import Link from 'gatsby-link'
import idx from 'idx'
import * as React from 'react'
import * as ReactTooltip from 'react-tooltip'
import BlogPost from '../components/BlogPost'
import Header from '../components/Header'
import Helmet from 'react-helmet'
import MailingListModal from '../components/MailingListModal'

interface IBlogPostByPathProps {
  data: {
    markdownRemark: {
      id: string
      html: string
      frontmatter: {
        date: string
        path: string
        title: string
        author: string
      }
    }
  }
}

function Template(props: IBlogPostByPathProps) {
  const markdownRemark = props.data.markdownRemark;

  return (
    <div className="page__blog__wrapper">
      <div className="page page__blog">
        <ReactTooltip className="tooltip" place="bottom" aria-haspopup="true" />
        <Header />
        <Helmet title={markdownRemark.frontmatter.title} />
        <Link className="circlelink blog__post__solo__back" to="/blog">← All posts</Link>
        <BlogPost className="blog__post__solo" post={markdownRemark} />
        <MailingListModal />
      </div>
    </div>
  )  
}

export default Template

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path }}) {
      html
      frontmatter {
        date
        path
        title
        author
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/templates/blogTemplate.tsx